(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("$"), require("VueColor"));
	else if(typeof define === 'function' && define.amd)
		define(["$", "VueColor"], factory);
	else if(typeof exports === 'object')
		exports["g5-vue-ctrls"] = factory(require("$"), require("VueColor"));
	else
		root["g5-vue-ctrls"] = factory(root["$"], root["VueColor"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_88__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 28);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 12:
/***/ (function(module, exports) {


function Dictionary() {
    this._dictionary = {};
}

Dictionary.prototype.get = function (key) {
    return this._dictionary[key];
};
Dictionary.prototype.clear = function () {
    this._dictionary = {};
};
Dictionary.prototype.add = function (key, value) {
    this._dictionary[key] = value;
};

module.exports = Dictionary;

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(85),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9fe03e78",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(71),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b1cb026",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

var aggregateItem = __webpack_require__(17);
var colorbox = __webpack_require__(18);

var Dictionary = __webpack_require__(12);
var directives = __webpack_require__(3);

module.exports = {
    aggregateItem: aggregateItem,
    colorbox: colorbox,

    Dictionary: Dictionary,
    directives: directives
};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {



function prevent(e) {
    if (e.preventDefault != null) {
        e.preventDefault();
    } else {
        e.returnValue = false;
    }
}

function selectionStart(input) {
    if (!input) {
        return -1;
    }
    if (input.selectionStart != null) {
        return input.selectionStart;
    }

    try {
        var range = document.selection.createRange();
        range.moveStart('character', -input.value.length);
        return range.text.length;
    } catch (e) {
        return 0;
    }
}

function onNumberKeydown(flag) {
    return function (e) {
        if (e.keyCode === 8 || e.keyCode === 9) {} else if (e.keyCode === 46) {} else if (e.keyCode >= 35 && e.keyCode <= 40) {} else if (e.keyCode === 65 && e.ctrlKey) {} else if (flag === 'float' && (e.keyCode === 110 || e.keyCode === 190)) {
            if (this.value.indexOf('.') >= 0) {
                prevent(e);
            }
        } else if (e.keyCode === 173 || e.keyCode === 189 || e.keyCode === 109) {
            if (flag === 'noneg') {
                prevent(e);
            } else if (this.value.indexOf('-') >= 0) {
                prevent(e);
            } else if (selectionStart(e.target) !== 0) {
                prevent(e);
            }
        } else if ((e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
            prevent(e);
        } else if (e.shiftKey) {
            prevent(e);
        }
    };
}

module.exports = {
    install: function install(Vue) {
        Vue.directive('fic-number', {
            bind: function bind(el, binding) {
                el.addEventListener('keydown', onNumberKeydown(binding.arg));
            }
        });
    },

    options: {
        bind: function bind(el, binding) {
            if (binding.value === true) {
                el.addEventListener('keydown', onNumberKeydown(binding.arg));
            }
        }
    }
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),

/***/ 45:
/***/ (function(module, exports) {



module.exports = {
    props: {
        field: String,
        item: Object,
        source: Array
    },
    data: function data() {
        return {
            itemReadonly: true
        };
    },

    computed: {
        innerItem: function innerItem() {
            return this.item || {};
        }
    },
    mounted: function mounted() {
        this.typeChanged(this.$refs.type, true);
    },

    methods: {
        typeChanged: function typeChanged(target, firstload) {
            this.innerItem.type = target.value;
            this.itemReadonly = !/^expression$/i.test(target.value);
            if (this.itemReadonly) {
                if (this.innerItem.type == null || /^\s*$/.test(this.innerItem.type)) {
                    this.innerItem.expression = '';
                } else {
                    var items = Array.prototype.filter.call(target.children, function (item) {
                        return item.selected;
                    });
                    if (items.length > 0) {
                        this.innerItem.expression = items[0].innerText + '()';
                    }
                }
            } else if (!firstload || this.innerItem.expression == null || this.innerItem.expression.length === 0) {
                this.innerItem.expression = 'Count([' + this.field + '])';
            }
        },
        valueChanged: function valueChanged(target) {
            this.innerItem.expression = target.value;
        },
        onMultiLangs: function onMultiLangs() {
            if (typeof this.innerItem.onMultiLangs === 'function') {
                this.innerItem.onMultiLangs();
            }
        }
    }
};

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {



var vueColor = __webpack_require__(88);
var $ = __webpack_require__(4);

if (vueColor == null) {
    vueColor = window.VueColor;
}
if (vueColor == null && window.parent != null) {
    vueColor = window.parent.VueColor;
}
var sketch = vueColor.Sketch;
var defaultPresetColors = sketch.data().presetColors;

function offsetPosition(el) {
    return el.getBoundingClientRect();
}

function getRgba(hex) {
    var r = /^#([\dA-Fa-f]{2})([\dA-Fa-f]{2})([\dA-Fa-f]{2})$/.exec(hex);
    if (r == null) {
        return { r: 0, g: 0, b: 0, a: 1 };
    }
    return {
        r: parseInt(r[1], 16),
        g: parseInt(r[2], 16),
        b: parseInt(r[3], 16),
        a: 1
    };
}

module.exports = {
    props: {
        value: [String, Object],
        presets: Array,
        transparent: Boolean,
        enabled: null,
        window: null
    },
    data: function data() {
        if (this.transparent && (this.value == null || this.value.length === 0)) {
            return {
                colorPanelVisible: false,
                colorObject: {
                    hex: 'None',
                    rgba: { r: 0, g: 0, b: 0, a: 0 }
                }
            };
        }
        var val = this.value || '#000000';
        if (val.length > 7) {
            val = '#' + val.substring(3);
        }
        return {
            colorPanelVisible: false,
            colorObject: {
                hex: val,
                rgba: getRgba(val)
            }
        };
    },

    computed: {
        hexColor: function hexColor() {
            var rgba = this.colorObject.rgba || { r: 0, g: 0, b: 0, a: 1 };
            return 'rgba(' + rgba.r + ', ' + rgba.g + ', ' + rgba.b + ', ' + rgba.a + ')';
        },
        colorLabel: function colorLabel() {
            var color = this.colorObject.hex;
            var c = this.presets.filter(function (v) {
                return v.color === color;
            });
            return c && c.length > 0 ? c[0].text : color;
        }
    },
    components: {
        'sketch-color': sketch
    },
    mounted: function mounted() {
        if (this.presets != null) {
            this.$refs.colorpicker.presetColors = this.presets.map(function (c) {
                return c.color;
            });
        }

        $(this.$refs.colorpicker_wrapper).detach();
        $((this.window || window).document.body).append(this.$refs.colorpicker_wrapper);
        $(this.$refs.colorpicker.$el).detach();
        $((this.window || window).document.body).append(this.$refs.colorpicker.$el);
    },

    watch: {
        presets: function presets(v) {
            v = v && v.map(function (c) {
                return c.color;
            });
            this.$refs.colorpicker.presetColors = v || defaultPresetColors;
        },
        value: function value(v) {
            if (this.transparent && (v == null || v === '')) {
                this.colorObject = {
                    hex: 'None',
                    rgba: { r: 0, g: 0, b: 0, a: 0 }
                };
            } else {
                this.colorObject = {
                    hex: v || '#000000',
                    rgba: getRgba(v)
                };
            }
        }
    },
    methods: {
        onColorChanged: function onColorChanged(c) {
            this.colorObject = c;
            this.$emit('input', c.hex);
        },
        onclickPanel: function onclickPanel() {
            if (this.enabled === false) {
                return;
            }
            var el = this.$el;
            var pos = offsetPosition(el);
            var panel = this.$refs.colorpicker.$el;
            panel.style.left = pos.left + 'px';
            var screenHeight = $(this.window || window).height();
            var top = pos.top + el.offsetHeight;
            var panelHeight = $(panel).height();
            if (top + panelHeight + 20 > screenHeight) {
                top = screenHeight - panelHeight - 20;
            }
            panel.style.top = top + 'px';
            this.colorPanelVisible = true;
        },
        onmousedownWrapper: function onmousedownWrapper() {
            this.colorPanelVisible = false;
        }
    }
};

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selector",
    style: ({
      background: _vm.enabled === false && 'none'
    })
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    },
    on: {
      "click": _vm.onclickPanel
    }
  }, [_c('span', {
    staticClass: "color-block"
  }, [_c('div', {
    staticClass: "color-block-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "color-block-cell",
    style: ({
      backgroundColor: _vm.hexColor
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "color-label"
  }, [_vm._v(_vm._s(_vm.colorLabel))]), _vm._v(" "), (_vm.enabled !== false) ? _c('span', {
    staticClass: "color-drop"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.colorPanelVisible),
      expression: "colorPanelVisible"
    }],
    ref: "colorpicker_wrapper",
    staticClass: "wrapper",
    on: {
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.onmousedownWrapper($event)
      }
    }
  }), _vm._v(" "), _c('sketch-color', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.colorPanelVisible),
      expression: "colorPanelVisible"
    }],
    ref: "colorpicker",
    staticClass: "wrapper-color",
    attrs: {
      "value": _vm.colorObject
    },
    on: {
      "input": _vm.onColorChanged
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "fi-input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerItem.caption),
      expression: "innerItem.caption"
    }],
    staticClass: "caption",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.innerItem.caption)
    },
    on: {
      "focus": function($event) {
        return _vm.$emit('focused', _vm.innerItem, 'caption')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerItem, "caption", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "fa fi-multilangs",
    on: {
      "mouseup": _vm.onMultiLangs
    }
  })]), _c('select', {
    ref: "type",
    staticClass: "type",
    domProps: {
      "value": _vm.innerItem.type
    },
    on: {
      "change": function($event) {
        return _vm.typeChanged($event.target)
      },
      "focus": function($event) {
        return _vm.$emit('focused', _vm.innerItem, 'type')
      }
    }
  }, [_vm._l((_vm.source), function(item, idx) {
    return [_c('option', {
      key: idx,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])]
  })], 2), _c('input', {
    class: ['expr', _vm.itemReadonly && 'readonly'],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.innerItem.expression,
      "readOnly": _vm.itemReadonly
    },
    on: {
      "focus": function($event) {
        return _vm.$emit('focused', _vm.innerItem, 'expression')
      },
      "input": function($event) {
        return _vm.valueChanged($event.target)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_88__;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// js/vue-ctrls.js?ee21d614aa0b2fb92c7c